import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

export type EmbeddedLoginParams = {
  token: string;
  fhirPatientId?: string;
  fhirEncounterId?: string;
};

export type EmbeddedLoginResponse = {
  access_token: string;
  user: {
    id: string;
    tenantId: string;
    email: string;
    name: string;
    givenName?: string;
    familyName?: string;
    vimUserId?: string;
    ehrUsername?: string;
  };
  org_uuid: string;
  org_name?: string;
  vim_organization_id?: string;
  vim_organization_name?: string;
  fhirPatientId?: string;
  fhirEncounterId?: string;
  success: boolean;
};

export const useEmbeddedLogin = (
  options?: UseMutationOptions<
    EmbeddedLoginResponse,
    Error,
    EmbeddedLoginParams
  >
) => {
  const { mutateAsync, ...rest } = useMutation<
    EmbeddedLoginResponse,
    Error,
    EmbeddedLoginParams
  >({
    mutationFn: (params: EmbeddedLoginParams) =>
      integrationsApi
        .post<EmbeddedLoginResponse>('/v3/embedded/login', params)
        .then((res) => res.data),
    ...options,
  });

  return { embeddedLogin: mutateAsync, ...rest };
};
